const CaretDownIcon = ({ color = 'currentColor' }) => {
  return (
    <svg
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M10 0L5 6L0 0L10 0Z" fill={color} />
    </svg>
  );
};

export default CaretDownIcon;
